import React from 'react'

const Loading = () => {
	return (
		<div 
			className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
			style={{cursor: 'wait'}}
		>
			<div className="flex flex-col gap-2 items-center bg-zinc-800 p-5 rounded-lg">
				<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white"/>
				<span className={"text-white"}>처리중...</span>
			</div>
		</div>
	);
};

export default Loading;